var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSigned(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2943_16870)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.58838 0C4.17691 0 0.588379 3.58853 0.588379 8C0.588379 12.4115 4.17691 16 8.58838 16C12.9998 16 16.5884 12.4108 16.5884 8C16.5884 3.58916 12.9998 0 8.58838 0ZM8.58838 14.7607C4.86104 14.7607 1.82772 11.728 1.82772 8C1.82772 4.27203 4.86104 1.23934 8.58838 1.23934C12.3163 1.23934 15.349 4.27203 15.349 8C15.349 11.728 12.3157 14.7607 8.58838 14.7607Z",
    fill: "#17B67C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2592 5.2173C12.007 4.98802 11.6147 5.00599 11.3842 5.25942L7.60419 9.4218L5.77799 7.56527C5.53693 7.32111 5.14531 7.31739 4.90177 7.55783C4.65762 7.79764 4.6539 8.18989 4.89434 8.43405L7.18031 10.7578C7.29744 10.8768 7.45606 10.9431 7.62212 10.9431C7.62584 10.9431 7.63019 10.9431 7.6339 10.9437C7.80494 10.94 7.96606 10.8669 8.08069 10.7405L12.3013 6.09292C12.5312 5.83883 12.5126 5.4472 12.2592 5.2173Z",
    fill: "#17B67C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2943_16870"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.588379)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSigned);
export default __webpack_public_path__ + "static/media/signed.1f212c87464636b9951b0a742ee107ac.svg";
export { ForwardRef as ReactComponent };